export default class Sector {
  id = null
  label = null
  children = []
  sectorsToCheck = []
  sectorsToDisable = []
  isDisabled = false
  wayToSector = []
  customLabel = null

  constructor(object) {
    Object.assign(this, object)
    this.label = object.name
    this.customLabel = object.short_name ?? object.name
    delete this.name
    delete this.sectors_check
    delete this.sectors_disable
    delete this.short_name
  }
}
